import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach token from localStorage as fallback (mobile Safari may block 3rd-party cookies)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("pawlink_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function fileUrl(path) {
    if (!path) return null;
    return `${API}/files/${path}`;
}

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

/**
 * Detects the standardized backend Premium-required response:
 *   HTTP 402  { detail: { detail: "...", code: "PREMIUM_REQUIRED" } }
 * Returns true for that exact shape; false otherwise (including plain 402
 * responses from the free-pet-limit endpoint, which uses a different
 * detail shape and must NOT be treated as a Premium-feature gate).
 */
export function isPremiumRequiredError(err) {
    if (err?.response?.status !== 402) return false;
    const d = err.response.data?.detail;
    return d && typeof d === "object" && d.code === "PREMIUM_REQUIRED";
}

export default api;
